import React from "react";
import { IChangePasswordPresenter } from "../../presenter/ChangePasswordPresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import PasswordChangeForm from "../forms/PasswordChangeForm";

export interface Props extends PageProps {}
export interface State extends IChangePasswordPresenter {}

export default class PasswordChangePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      password,
      submitButtonDisabled,
      validationPasswordErrors,
      changePassword,
      setPasswordValue,
      onClickBackButton,
      setPassword
    } = this.state;

    return (
      <Page {...this.props} className="login-wrapper">
        <PasswordChangeForm
          password={password}
          translate={translate}
          setPasswordValue={setPasswordValue}
          disableButton={submitButtonDisabled}
          changePassword={changePassword}
          validationErrors={validationPasswordErrors}
          loading={this.state.loaders.changePasswordLoader}
          onClickBackButton={onClickBackButton}
          setPassword={setPassword}
        />
      </Page>
    );
  }
}
